export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const emailValidation = {
  value: emailRegex,
  message: 'Please enter a valid email',
}

export const linkedinUrlValidation = {
  value: /^(https?:\/\/)?([\w\d]+\.)?linkedin\.com\/in\/[\w\d-]+\/?$/,
  message: 'Please enter a valid LinkedIn URL',
}

/**
 * This regex is used to validate phone numbers in the following formats:
 * 123-456-7890
 * 123-456-78
 * 123 456 7890
 * For the different international formats for phone numbers
 */
export const formattedPhoneValidation = {
  value:
    /^(\d{3}-\d{3}-\d{4})$|^(\d{3}-\d{3}-\d{2})$|^(\d{3} \d{4} \d{4})$|^(\d{4} \d{4} \d{4})$/,
  message: 'Please enter a valid phone number',
}

export const simpleUrlRegex = {
  // eslint-disable-next-line no-useless-escape
  value: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?$/,
  message: 'Must be a valid URL',
}

export function isValidDate(year: string, month: string, day: string) {
  // Create a new Date object (month is 0-indexed)
  const date = new Date(Number(year), Number(month) - 1, Number(day))
  if (date.toString() === 'Invalid Date') return false

  // Check if the year, month, and day match the input values
  return (
    date.getFullYear() === Number(year) &&
    date.getMonth() === Number(month) - 1 &&
    date.getDate() === Number(day)
  )
}
